import styled, { css } from 'styled-components';
import color from '@deprecated-ui/_style/color';
import device from '@deprecated-ui/_style/device';
import {
  ContainerImagesProps,
  ImageProps,
  ActionIconWrapperProps,
  ContainerImageProps,
  SliderDotProps,
} from './types';

const FrameStyle = {
  FRAME_TYPE_SQUARE: css`
    aspect-ratio: 1;
  `,
  FRAME_TYPE_PORTRAIT: css`
    aspect-ratio: 0.8;
  `,
  FRAME_TYPE_LANDSCAPE: css`
    aspect-ratio: 1.78;
  `,
};

const ImageItemStyle = {
  FRAME_TYPE_SQUARE: {
    FRAME_TYPE_LANDSCAPE: css`
      max-height: 888px;
      width: 100%;
      max-width: 100%;
      object-fit: fill;
    `,
    FRAME_TYPE_SQUARE: css`
      max-height: 888px;
      width: 100%;
      height: max-content;
      max-width: 100%;
      object-fit: fill;
    `,
    FRAME_TYPE_PORTRAIT: css``,
  },
  FRAME_TYPE_PORTRAIT: {
    FRAME_TYPE_LANDSCAPE: css`
      max-height: 697.5px;
      width: 100%;
      max-width: 100%;
      height: fit-content;
    `,
    FRAME_TYPE_SQUARE: css`
      max-height: 697.5px;
      width: 100%;
      max-width: 100%;
    `,
    FRAME_TYPE_PORTRAIT: css`
      max-height: 100%;
      width: auto;
      max-width: 100%;
      height: auto;
    `,
  },
  FRAME_TYPE_LANDSCAPE: {
    FRAME_TYPE_LANDSCAPE: css`
      max-height: 100%;
      /* height: auto; */
      max-width: 100%;
      object-fit: fill;
    `,
    FRAME_TYPE_SQUARE: css``,
    FRAME_TYPE_PORTRAIT: css``,
  },
};

const ImageStyle = {
  FRAME_TYPE_UNSPECIFIED: {
    post: css`
      max-height: max-content;
      width: 100%;
      object-fit: fill;
    `,
    comment: css`
      max-height: max-content;
      width: 100%;
      object-fit: fill;
    `,
  },
  FRAME_TYPE_SQUARE: {
    post: css`
      max-height: max-content;
      max-width: 100%;
      width: 100%;
      object-fit: cover;
      height: 100%;
    `,
    comment: css`
      max-height: max-content;
      width: 100%;
      object-fit: fill;
      height: 100%;
    `,
  },
  FRAME_TYPE_PORTRAIT: {
    post: css`
      max-height: 697.5px;
      width: auto;
      max-width: 100%;
      /* height: 100%; */
    `,
    comment: css`
      max-height: 431.25px;
      width: auto;
      max-width: 100%;
      object-fit: fill;
      height: 100%;
    `,
  },
  FRAME_TYPE_LANDSCAPE: {
    post: css`
      max-height: max-content;
      width: 100%;
      max-width: 100%;
      object-fit: fill;
    `,
    comment: css`
      max-height: max-content;
      width: 100%;
      max-width: 100%;
      object-fit: fill;
    `,
  },
};

const ContainerImages = styled.div<ContainerImagesProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${color.downgray};
  border-radius: 3px;
  ${({ frameType }) => FrameStyle[frameType]};

  width: calc(100% + 40px);
  left: -20px;
  @media ${device.tablet} {
    width: 100%;
    left: unset;
  }
`;

const ContainerImage = styled.div<ContainerImageProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: max-content;
  ${({ isGif }) =>
    isGif &&
    css`
      background: ${color.downgray};
    `}
  /* background: ${color.downgray}; */

  width: calc(100% + 40px);
  left: -20px;
  @media ${device.tablet} {
    width: unset;
    left: unset;
  }
`;

const ImageItem = styled.img.attrs({
  loading: 'lazy',
})<ImageProps>`
  object-fit: fill;
  ${({ imageFrameType, frameType }) =>
    ImageItemStyle[frameType][imageFrameType]}
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  aspect-ratio: ${({ ratio }) => ratio || 'unset'};
  background: ${color.light};
  border-radius: 3px;
  cursor: pointer;
`;

const ImageSingle = styled.img.attrs({
  loading: 'lazy',
})<ImageProps>`
  object-fit: fill;
  object-position: 50% 50%;
  border-radius: 3px;
  ${({ imageFrameType, mode }) => ImageStyle[imageFrameType][mode]}
  ${({ isGif }) =>
    isGif &&
    css`
      height: 200px;
      width: auto;
      max-width: 100%;
    `}
`;

const ActionIconWrapper = styled.button<ActionIconWrapperProps>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  position: absolute;
  top: 50%;
  border-radius: 50%;
  padding: 2px;
  border: none;
  cursor: pointer;
  background: ${color.component};
  right: ${({ position }) => (position === 'left' ? 'unset' : '10px')};
  left: ${({ position }) => (position === 'left' ? '10px' : 'unset')};
  opacity: 0.8;

  p {
    font-size: 19.5px;
    color: ${color.dimgray};
    padding: 4.5px;
  }
`;

const CounterContainer = styled.div`
  background: ${color.component};
  opacity: 0.8;
  border-radius: 12px;
  height: 24px;
  width: 34px;
  position: absolute;
  right: 12px;
  top: 12px;
  padding: 4px 8px;
`;

const SliderFooterContainer = styled.ul`
  width: 100%;
  padding-inline-start: 0;
  text-align: center;
`;

const SliderDot = styled.li<SliderDotProps>`
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  margin-right: 6px;

  border: 1px solid #ededed;
  width: 4px;
  height: 4px;
  border-radius: 100%;

  ${({ active }) =>
    active &&
    css`
      border: 1px solid #00ab6b;
      background-color: #00ab6b;
      width: 16px;
      height: 4px;
      border-radius: 20px;
    `}
`;

export {
  ContainerImages,
  ImageItem,
  ContainerImage,
  ImageSingle,
  ActionIconWrapper,
  CounterContainer,
  SliderFooterContainer,
  SliderDot,
};
